import { render, staticRenderFns } from "./OrderSplitPopup.vue?vue&type=template&id=0b34657c"
import script from "./OrderSplitPopup.vue?vue&type=script&lang=js"
export * from "./OrderSplitPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../ClientApp/wwwroot/dashboard/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports